// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"9eb1ad45","650":"fc46b11a"}[chunkId] + ".chunk.js";
};